import {
  SUPPORTED_LANGUAGES_MAP,
  SupportedLanguage,
} from '~/constants/languages';
import {
  PaymentMethod,
  carriers_payment_methods,
  payment_methods,
} from '~/lib/payment';
import { findLanguagePaymentNames } from '~/src/services/i18n/payments';
import type { ApiPaymentMethod } from '~/types/resources/apiPaymentMethod';

export const getGachaPaymentList = (
  gachaPaymentMethods: ApiPaymentMethod[],
  options?: { lang?: SupportedLanguage }
) => {
  const rawPaymentList = payment_methods.filter((item) => {
    return (gachaPaymentMethods ?? []).some((paymentMethod) => {
      return paymentMethod.type == item.id && paymentMethod.is_available;
    });
  });
  if (
    options == undefined ||
    options?.lang == SUPPORTED_LANGUAGES_MAP.ja ||
    options?.lang == undefined
  ) {
    return rawPaymentList;
  }

  const paymentNames = findLanguagePaymentNames(options.lang);
  if (paymentNames == null) {
    return rawPaymentList;
  }

  return rawPaymentList.map((item) => {
    const paymentName = paymentNames[item.id];
    return {
      ...item,
      display_name: paymentName ?? item.display_name,
    };
  });
};

export const getGachaCarrierPaymentList = (PaymentMethods: PaymentMethod[]) => {
  return carriers_payment_methods.filter((item) => {
    return (PaymentMethods ?? []).some((paymentMethod) => {
      return paymentMethod.id == item.id;
    });
  });
};
